module.exports = "/_next/static/images/video_id_7103210750990224683-e7c9f0e27ed039eef6608c74eea9cb85.jpg";